$(function() {
    const key = 'basket_dropout_pending_capture';
    const pending = sessionStorage.getItem(key);
    const $detailsForm = $('#checkout-details-step-from');
    const $emailField = $('#form_email_email_first');
    const $phoneField = $('#form_phone_phoneNumber');
    const $consent = $('[data-basket-dropout-consent]');

    if (pending !== null) {
        sessionStorage.removeItem(key);
        $.post('/basket-dropout/capture', {
            optOut: pending
        });
    }

    function isValidEmail(email) {
        return /^.+@.+\..+$/.test(email);
    }

    function isValidPhone(phone) {
        let normalized = (phone || '').replace(/\s+/g, '');

        if (/^7\d{9}$/.test(normalized)) {
            normalized = '0' + normalized;
        }

        return /^07\d{9}$/.test(normalized);
    }

    function toggleConsentVisibility() {
        if (!$consent.length) {
            return;
        }

        if (isValidEmail($emailField.val()) && isValidPhone($phoneField.val())) {
            $consent.removeClass('hide');
            return;
        }

        $consent.addClass('hide');
        $('[data-basket-dropout-opt-out]').prop('checked', false);
    }

    if ($detailsForm.length) {
        $detailsForm.on('input change blur', '#form_email_email_first, #form_phone_phoneNumber', toggleConsentVisibility);
        toggleConsentVisibility();

        $detailsForm.find('button[type="submit"]').on('click', function() {
            const optedOut = $('[data-basket-dropout-opt-out]').is(':checked');
            sessionStorage.setItem(key, optedOut ? '1' : '0');
        });
    }
});
